import xs from "xstream"
import isolate from "@cycle/isolate"
import * as R from "ramda"

import {dumper} from '../../utils'
import {PAGE, STATE_KEY} from '../../constant'

import {pageViewTempl, input2Prop, createApiReq, createApiResp} from '../common'

import {view} from './view'

const forgotReq = createApiReq("forgot");
const forgotResp = createApiResp("forgot");

/* IMPURE TERM CHECK */
const Forgot = sources => {
	const eventInfo$ = sources.state.select([STATE_KEY.Event])
	const email$ = sources.DOM.select("#email").events("input")
		.map(input2Prop("mailAddress"))
		.startWith({mailAddress: ''})
		.remember()

	const forgotReq$ = sources.DOM.select("#btnQuery").events("click")
		.map(() => email$.map(forgotReq).take(1))
		.flatten()

	const forgotResp$ = sources.HTTP.select("forgot")
		.map(resp$ => resp$.replaceError(() => xs.of({body: {message:"通信エラー", status: -5}})))
		.flatten()
		.map((resp: any) => {
      if (R.path(["body", "message"], resp)) {
        return R.path(["body", "message"], resp)
      } else if (R.path(["body", "data", "message"], resp)) {
        return R.path(["body", "data", "message"], resp)
      }
      return "サーバエラー"
    });

	forgotResp$.addListener(dumper("ret"))
	const msg$ = xs.merge(forgotResp$).startWith(null)

	const isBusy$ = xs.merge(forgotReq$.mapTo(true), forgotResp$.mapTo(false))

	const btnReturn$ = sources.DOM.select("#btnReturn").events("click").mapTo({type: "goBack"}); 
	const view$ = view(msg$, email$)
	const pageView = pageViewTempl(PAGE.Forgot.id, eventInfo$)
	return {
		DOM: pageView(view$),
		HTTP: forgotReq$,
		loading: isBusy$,
		router: xs.merge(btnReturn$),
	}
}
export default sources => isolate(Forgot)(sources)
